import { ChatAgentToolName } from '@/types/chat';

interface FormattedToolCall {
  title: string;
  fullDescription: string;
}

export function formatToolCall(
  toolName: ChatAgentToolName,
  args: string | Record<string, unknown>,
): FormattedToolCall {
  const parsedArgs: Record<string, unknown> =
    typeof args === 'string' ? JSON.parse(args) : args;

  switch (toolName) {
    case ChatAgentToolName.SearchByKeyword:
      return {
        title: 'Searching workspace data',
        fullDescription: `Searching workspace data for "${parsedArgs.keyword}"`,
      };
    case ChatAgentToolName.QueryDb:
      return {
        title: 'Querying workspace data',
        fullDescription: `Querying workspace data for "${parsedArgs.natural_language_query}"`,
      };
    case ChatAgentToolName.ReadCustomer:
      return {
        title: 'Reading customer',
        fullDescription: `Reading customer with UUID ${parsedArgs.customer_uuid}`,
      };
    case ChatAgentToolName.ReadDocument:
      return {
        title: 'Reading document',
        fullDescription: `Reading document with ID ${parsedArgs.document_id}`,
      };
    case ChatAgentToolName.Calculate:
      const formattedOperation = (parsedArgs.operation as string).toLowerCase();
      const formattedNumbers = (parsedArgs.numbers as Array<number>).join(', ');
      return {
        title: 'Using calculator',
        fullDescription: `Using calculator to ${formattedOperation} ${formattedNumbers}`,
      };
    case ChatAgentToolName.SearchKnowledgebase:
      return {
        title: 'Searching knowledgebase',
        fullDescription: `Searching knowledgebase for "${parsedArgs.search_phrase}"`,
      };
    case ChatAgentToolName.AnalyseTransactions:
      return {
        title: 'Analysing transactions',
        fullDescription: `Analysing transactions for document with ID ${parsedArgs.document_id}`,
      };
    case ChatAgentToolName.CheckSummarySection:
      const formattedAmounts = (
        parsedArgs.amounts as Array<{
          is_positive: boolean;
          value: number;
          type: string;
        }>
      )
        .map((amt) => `${amt.is_positive ? '' : '-'}${amt.value} (${amt.type})`)
        .join(', ');
      return {
        title: 'Checking summary section',
        fullDescription: `Checking summary section for document with ID ${parsedArgs.document_id} and amounts ${formattedAmounts}`,
      };
    case ChatAgentToolName.CompareNames:
      return {
        title: 'Comparing names',
        fullDescription: `Comparing names ${parsedArgs.name_one} and ${parsedArgs.name_two}`,
      };
    default:
      return {
        title: 'Calling tool',
        fullDescription: `Calling tool ${toolName} with args ${JSON.stringify(parsedArgs)}`,
      };
  }
}
